<template>
  <div
    class="modal fade"
    id="garageModal"
    tabindex="-1"
    aria-labelledby="garageModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="garageModalLabel">
            {{ data.name }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="garage-modal">
            <div class="garage-modal__portrait">
              <img
                v-if="data.portrait_image"
                :src="data.portrait_image"
                alt=""
              />
            </div>
            <div class="d-flex flex-column gap-6">
              <!-- Valoración -->
              <div class="align-items-start d-flex gap-3">
                <div
                  class="garage-modal__rating garage-modal__rating--secondary"
                >
                  <div class="rating__average">
                    <div class="average__box">
                      <div class="average__total">Valoración</div>
                      <div class="align-self-center">
                        <div class="average__number">
                          {{
                            data.rating
                              ? data.rating
                              : data.rating_count?.average
                                ? data.rating_count?.average
                                : '0'
                          }}
                        </div>
                        <div class="average__stars">
                          <template v-for="n in rating_integer" v-bind:key="n">
                            <svg
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                              x="0px"
                              y="0px"
                              width="47.94px"
                              height="45.85px"
                              viewBox="0 0 47.94 45.85"
                              style="enable-background: new 0 0 47.94 45.85"
                              xml:space="preserve"
                            >
                              <path
                                class="st0"
                                style="fill: #ed8a19"
                                d="M26.28,1.44l5.41,10.96c0.38,0.76,1.1,1.29,1.94,1.41l12.09,1.76c2.12,0.31,2.96,2.91,1.43,4.4l-8.75,8.53 c-0.61,0.59-0.89,1.45-0.74,2.28l2.06,12.04c0.36,2.11-1.85,3.72-3.75,2.72l-10.81-5.69c-0.75-0.4-1.65-0.4-2.4,0l-10.81,5.69 c-1.89,1-4.11-0.61-3.75-2.72l2.06-12.04c0.14-0.84-0.13-1.69-0.74-2.28l-8.75-8.53c-1.53-1.49-0.69-4.1,1.43-4.4l12.09-1.76 c0.84-0.12,1.57-0.65,1.94-1.41l5.41-10.96C22.6-0.48,25.34-0.48,26.28,1.44z"
                              />
                            </svg>
                          </template>
                          <template
                            v-if="rating_integer < 5 && rating_decimal > 0"
                          >
                            <svg
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                              x="0px"
                              y="0px"
                              width="23.97px"
                              height="45.84px"
                              viewBox="0 0 23.97 45.84"
                              style="enable-background: new 0 0 23.97 45.84"
                              xml:space="preserve"
                            >
                              <path
                                class="st0"
                                style="fill: #ed8a19"
                                d="M23.97,0v39.55c-0.41,0-0.82,0.1-1.2,0.3l-10.81,5.69c-1.89,1-4.11-0.61-3.75-2.72l2.06-12.04 c0.14-0.84-0.13-1.69-0.74-2.28l-8.75-8.53c-1.53-1.49-0.69-4.1,1.43-4.4l12.09-1.76c0.84-0.12,1.57-0.65,1.94-1.41l5.41-10.96 C22.13,0.48,23.04,0,23.97,0z"
                              />
                            </svg>
                          </template>
                        </div>
                      </div>
                      <div class="average__total">
                        {{ data.rating_count?.total }}
                        {{
                          data.rating_count?.total == 1 ? 'reseña' : 'reseñas'
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex flex-column gap-3">
                  <div class="d-flex gap-3">
                    <div class="info__box">
                      <div class="info__label">
                        Categoría <span>(Ver NOTA)</span>
                      </div>
                      <div class="info__content">
                        {{ getCategory(data.category) }}
                      </div>
                    </div>

                    <div class="info__box">
                      <div class="info__label">Garantía por trabajos</div>
                      <div class="info__content">
                        {{ data.guarantee_conditions }}
                      </div>
                    </div>
                  </div>
                  <div class="payment-methods">
                    <img
                      :src="`${urls.assets}frontend/img/mercado-pago.svg`"
                      alt="Mercado Pago"
                    />
                    <img
                      :src="`${urls.assets}frontend/img/visa.svg`"
                      alt="Mercado Pago"
                    />
                    <img
                      :src="`${urls.assets}frontend/img/mastercard.svg`"
                      alt="Mercado Pago"
                    />
                    <img
                      :src="`${urls.assets}frontend/img/american-express.svg`"
                      alt="Mercado Pago"
                    />
                    <img
                      :src="`${urls.assets}frontend/img/diners-club.svg`"
                      alt="Mercado Pago"
                    />
                    <img
                      :src="`${urls.assets}frontend/img/pago-efectivo.svg`"
                      alt="Mercado Pago"
                    />
                  </div>
                </div>
              </div>

              <!-- Marcas -->
              <div class="d-flex flex-column gap-3">
                <div class="icon-grid__title">Marcas que atiende</div>
                <div class="icon-grid__grid icon-grid__grid--brands">
                  <div
                    v-for="brand in data.brands"
                    :key="brand.name"
                    class="icon-grid__item"
                  >
                    <img :src="urls.assets + brand.icon" :alt="brand.name" />
                  </div>
                </div>
              </div>

              <!-- Servicios -->
              <div class="d-flex flex-column gap-3">
                <div class="icon-grid__title">Servicios que Brinda</div>
                <div class="icon-grid__grid icon-grid__grid--services">
                  <div
                    v-for="garage_specialtie in data.garage_specialties"
                    :key="garage_specialtie"
                    class="icon-grid__item"
                  >
                    <img
                      :src="urls.assets + garage_specialtie.icon"
                      :alt="garage_specialtie.content"
                    />
                    <span>{{ garage_specialtie.content }}</span>
                  </div>
                </div>
              </div>

              <div class="d-flex flex-column gap-3">
                <!-- Nota: Categorías -->
                <div class="garage-modal__note garage-modal__note--dashed">
                  <p>NOTA:</p>
                  <p>
                    La Categoría del taller está definida por el resultado de
                    una evaluación que comprende sus procesos, instalaciones, su
                    gestión, los equipos y herramientas, la certificación de los
                    técnicos y otros aspectos que, en su conjunto, determinan el
                    nivel de desarrollo del taller como empresa.
                  </p>
                  <p>
                    La categorización tiene cinco niveles: BÁSICO, ESTÁNDAR,
                    PRO, ADVANCED y PREMIUM.
                  </p>
                  <p>Las homologaciones se hacen regularmente.</p>
                </div>

                <!-- Comentarios -->
                <div v-if="data.comments" class="garage-modal__note">
                  <div class="note__title">Comentarios</div>
                  <div v-html="JSON.parse(data.comments)"></div>
                </div>

                <!-- Nota: Servicios -->
                <div class="garage-modal__note">
                  <p>
                    Los servicios están sujetos a la disponibilidad de repuestos
                    en el mercado local.
                  </p>
                </div>
              </div>

              <!-- Valoraciones y reseñas -->
              <div class="garage-modal__rating">
                <div class="rating__title">Valoraciones y reseñas</div>
                <div class="rating__average">
                  <div class="average__box">
                    <div class="average__number">
                      {{
                        data.rating
                          ? data.rating
                          : data.rating_count?.average
                            ? data.rating_count?.average
                            : '0'
                      }}
                    </div>
                    <div class="average__stars">
                      <template v-for="n in rating_integer" v-bind:key="n">
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          x="0px"
                          y="0px"
                          width="47.94px"
                          height="45.85px"
                          viewBox="0 0 47.94 45.85"
                          style="enable-background: new 0 0 47.94 45.85"
                          xml:space="preserve"
                        >
                          <path
                            class="st0"
                            style="fill: #ed8a19"
                            d="M26.28,1.44l5.41,10.96c0.38,0.76,1.1,1.29,1.94,1.41l12.09,1.76c2.12,0.31,2.96,2.91,1.43,4.4l-8.75,8.53 c-0.61,0.59-0.89,1.45-0.74,2.28l2.06,12.04c0.36,2.11-1.85,3.72-3.75,2.72l-10.81-5.69c-0.75-0.4-1.65-0.4-2.4,0l-10.81,5.69 c-1.89,1-4.11-0.61-3.75-2.72l2.06-12.04c0.14-0.84-0.13-1.69-0.74-2.28l-8.75-8.53c-1.53-1.49-0.69-4.1,1.43-4.4l12.09-1.76 c0.84-0.12,1.57-0.65,1.94-1.41l5.41-10.96C22.6-0.48,25.34-0.48,26.28,1.44z"
                          />
                        </svg>
                      </template>
                      <template v-if="rating_integer < 5 && rating_decimal > 0">
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          x="0px"
                          y="0px"
                          width="23.97px"
                          height="45.84px"
                          viewBox="0 0 23.97 45.84"
                          style="enable-background: new 0 0 23.97 45.84"
                          xml:space="preserve"
                        >
                          <path
                            class="st0"
                            style="fill: #ed8a19"
                            d="M23.97,0v39.55c-0.41,0-0.82,0.1-1.2,0.3l-10.81,5.69c-1.89,1-4.11-0.61-3.75-2.72l2.06-12.04 c0.14-0.84-0.13-1.69-0.74-2.28l-8.75-8.53c-1.53-1.49-0.69-4.1,1.43-4.4l12.09-1.76c0.84-0.12,1.57-0.65,1.94-1.41l5.41-10.96 C22.13,0.48,23.04,0,23.97,0z"
                          />
                        </svg>
                      </template>
                    </div>
                    <div class="average__total">
                      {{ data.rating_count?.total }}
                      {{ data.rating_count?.total == 1 ? 'reseña' : 'reseñas' }}
                    </div>
                  </div>
                  <div class="average__points">
                    <div class="point__box">
                      <div class="point__number">5</div>
                      <div class="point__bar">
                        <div
                          class="bar__background"
                          :style="
                            data.rating_count?.rating_5
                              ? 'width:' + data.rating_count?.rating_5 + '%'
                              : 'width:0%'
                          "
                        ></div>
                      </div>
                    </div>
                    <div class="point__box">
                      <div class="point__number">4</div>
                      <div class="point__bar">
                        <div
                          class="bar__background"
                          :style="
                            data.rating_count?.rating_4
                              ? 'width:' + data.rating_count?.rating_4 + '%'
                              : 'width:0%'
                          "
                        ></div>
                      </div>
                    </div>
                    <div class="point__box">
                      <div class="point__number">3</div>
                      <div class="point__bar">
                        <div
                          class="bar__background"
                          :style="
                            data.rating_count?.rating_3
                              ? 'width:' + data.rating_count?.rating_3 + '%'
                              : 'width:0%'
                          "
                        ></div>
                      </div>
                    </div>
                    <div class="point__box">
                      <div class="point__number">2</div>
                      <div class="point__bar">
                        <div
                          class="bar__background"
                          :style="
                            data.rating_count?.rating_2
                              ? 'width:' + data.rating_count?.rating_2 + '%'
                              : 'width:0%'
                          "
                        ></div>
                      </div>
                    </div>
                    <div class="point__box">
                      <div class="point__number">1</div>
                      <div class="point__bar">
                        <div
                          class="bar__background"
                          :style="
                            data.rating_count?.rating_1
                              ? 'width:' + data.rating_count?.rating_1 + '%'
                              : 'width:0%'
                          "
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="rating__user"
                  v-for="(rating_user, index) in rating_comments"
                  v-bind:key="index"
                >
                  <div class="user__name">
                    <div class="name__initial">
                      {{
                        rating_user.name
                          ? rating_user.name.charAt(0)
                          : rating_user.full_name.charAt(0)
                      }}
                    </div>
                    <div class="name__full">
                      {{ rating_user.name || rating_user.full_name }}
                      {{ rating_user.last_name }}
                    </div>
                  </div>
                  <div class="user__stars">
                    <div class="stars__box">
                      <template
                        v-for="n in rating_user.rating_integer"
                        v-bind:key="n"
                      >
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          x="0px"
                          y="0px"
                          width="47.94px"
                          height="45.85px"
                          viewBox="0 0 47.94 45.85"
                          style="enable-background: new 0 0 47.94 45.85"
                          xml:space="preserve"
                        >
                          <path
                            class="st0"
                            style="fill: #ed8a19"
                            d="M26.28,1.44l5.41,10.96c0.38,0.76,1.1,1.29,1.94,1.41l12.09,1.76c2.12,0.31,2.96,2.91,1.43,4.4l-8.75,8.53 c-0.61,0.59-0.89,1.45-0.74,2.28l2.06,12.04c0.36,2.11-1.85,3.72-3.75,2.72l-10.81-5.69c-0.75-0.4-1.65-0.4-2.4,0l-10.81,5.69 c-1.89,1-4.11-0.61-3.75-2.72l2.06-12.04c0.14-0.84-0.13-1.69-0.74-2.28l-8.75-8.53c-1.53-1.49-0.69-4.1,1.43-4.4l12.09-1.76 c0.84-0.12,1.57-0.65,1.94-1.41l5.41-10.96C22.6-0.48,25.34-0.48,26.28,1.44z"
                          />
                        </svg>
                      </template>
                      <template
                        v-if="
                          rating_user.rating_integer < 5 &&
                          rating_user.rating_decimal > 0
                        "
                      >
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          x="0px"
                          y="0px"
                          width="23.97px"
                          height="45.84px"
                          viewBox="0 0 23.97 45.84"
                          style="enable-background: new 0 0 23.97 45.84"
                          xml:space="preserve"
                        >
                          <path
                            class="st0"
                            style="fill: #ed8a19"
                            d="M23.97,0v39.55c-0.41,0-0.82,0.1-1.2,0.3l-10.81,5.69c-1.89,1-4.11-0.61-3.75-2.72l2.06-12.04 c0.14-0.84-0.13-1.69-0.74-2.28l-8.75-8.53c-1.53-1.49-0.69-4.1,1.43-4.4l12.09-1.76c0.84-0.12,1.57-0.65,1.94-1.41l5.41-10.96 C22.13,0.48,23.04,0,23.97,0z"
                          />
                        </svg>
                      </template>
                    </div>
                    <div class="stars__date">
                      {{
                        new Date(rating_user.created_at).toLocaleDateString(
                          'es-ES',
                          {
                            // day: 'numeric',
                            month: 'long',
                            year: 'numeric',
                          }
                        )
                      }}
                    </div>
                  </div>
                  <div class="user__comment" v-html="rating_user.comment"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn"
            v-if="frontpage"
            @click.prevent="scheduleAppointment(data.id)"
          >
            Agendar cita
          </button>
          <button
            type="button"
            class="btn btn--outline"
            data-bs-dismiss="modal"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { inject, ref, watch } from 'vue'
import Categories from '../../../general/js/utils/categories'

export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    url_validate_user: {
      type: String,
      default: '',
    },
    urls: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const loading = inject('loading')
    const frontpage = inject('frontpage')
    const user_id = inject('user_id')
    const rating_integer = ref(0)
    const rating_decimal = ref(0)
    const rating_comments = ref([])

    watch(
      () => props.data,
      (newValue) => {
        rating_integer.value = Math.trunc(Number(newValue.rating))
        rating_decimal.value = Number((Number(newValue.rating) % 1).toFixed(1))

        rating_comments.value = newValue.rating_comments.map((element) => {
          element.rating_integer = Math.trunc(Number(element.rating))
          element.rating_decimal = Number(
            (Number(element.rating) % 1).toFixed(1)
          )

          return element
        })
      }
    )

    const closeModal = () => {
      $('#garageModal').modal('hide')
      emit('close-modal')
    }

    const scheduleAppointment = async (id) => {
      loading.value = true

      try {
        const { data } = await axios.request({
          url: props.url_validate_user,
          method: 'POST',
          data: {
            id: id,
          },
        })

        loading.value = false

        window.location.href = data
      } catch (error) {
        console.error(error)

        loading.value = false
      }
    }

    const getCategory = (id) => {
      return Categories(id)
    }

    return {
      frontpage,
      rating_integer,
      rating_decimal,
      rating_comments,
      scheduleAppointment,
      closeModal,
      getCategory,
    }
  },
}
</script>
